import ActionsGenerator from '../../lib/ActionsGenerator'

const generator = new ActionsGenerator('network', '/networks')
const actions = generator.generate()

export default actions
